export default __webpack_public_path__ + "static/media/card-profile3.a61ac5af.jpg";